import AxiosAPI from '../../utils/AxiosAPI';

export const handleChangeCustomerCurrencyOpe = (formData, customerId, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${customerId}/change-currency`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleChangeCustomerStatusOpe = (formData, customerId, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${customerId}/status`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleChangeCustomerTypeOpe = (formData, customerId, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${customerId}/role`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleDisable2faOpe = (customerId, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${customerId}/disable-2fa`)
            .put()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleUpdateCustomerOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${formData.Id}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
export const handleCreateCustomerOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleGetAllCustomer = (params) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers`, {
                q: params.q,
                status: params.status,
                type: params['customer-type'],
                orderby: params['order-by'],
                sort: params.sort,
                page: params.page,
                cpp: 12
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleImportCustomer = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers-import/import-xlsx`)
            .post(formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName || '');
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
